import React, { useContext, useState } from 'react';
import { GlobalContext } from '../context/GlobalContext';
import Cookies from 'js-cookie';
import axios from 'axios';

const ChangePass = () => {
  const [input, setInput] = useState({
    current_password: '',
    new_password: '',
    new_confirm_password: '',
  });

  const { contextFunctions } = useContext(GlobalContext);

  const { logouthandler } = contextFunctions;

  const handleChange = (event) => {
    let value = event.target.value;
    let name = event.target.name;

    setInput({ ...input, [name]: value });
  };

  const handleChangePass = (event) => {
    event.preventDefault();

    let { current_password, new_password, new_confirm_password } = input;

    axios
      .post(
        'https://dev-example.sanbercloud.com/api/change-password',
        {
          current_password,
          new_password,
          new_confirm_password,
        },
        { headers: { Authorization: 'Bearer ' + Cookies.get('token') } }
      )
      .then((res) => {
        let data = res.data;
        console.log(res);
        alert(res.data);
        logouthandler();
      })

      .catch((error) => {
        // console.log(error)
        alert(error.message);
      });
  };

  return (
    <div className="col-10">
      <h1 className="text-center">Form Data</h1>
      <form onSubmit={handleChangePass} className="row g-3">
        <div className="col-12">
          <label htmlFor="current_password" className="form-label">
            Password saat ini
          </label>
          <input
            type="text"
            className="form-control"
            id="current_password"
            onChange={handleChange}
            value={input.current_password}
            name="current_password"
            placeholder="Password saat ini..."
          />
        </div>

        <div className=" col-12">
          <label htmlFor="new_password" className="form-label">
            Password baru
          </label>
          <input
            type="text"
            className="form-control"
            id="new_password"
            onChange={handleChange}
            value={input.new_password}
            name="new_password"
            placeholder="Masukkan password baru..."
          ></input>
        </div>

        <div className=" col-12">
          <label htmlFor="new_confirm_password" className="form-label">
            Konfirmasi Password baru
          </label>
          <input
            type="text"
            className="form-control"
            id="new_confirm_password"
            onChange={handleChange}
            value={input.new_confirm_password}
            name="new_confirm_password"
            placeholder="Konfirmasi Password baru..."
          />
        </div>

        <button
          type="submit"
          className="ButtonForm btn btn-primary my-5 fw-semibold rounded-pill"
        >
          Submit
        </button>
      </form>
    </div>
  );
};

export default ChangePass;
